module.exports = __webpack_public_path__ + "img/1.39a2b08d.jpg";